import { CANONICAL_ORIGIN, canonicalUrl, ogImageUrl } from './siteConfig';
import { PRODUCT_MODULES } from './productModules';

const ORG_ID = `${CANONICAL_ORIGIN}/#organization`;
const WEBSITE_ID = `${CANONICAL_ORIGIN}/#website`;
const APP_ID = `${CANONICAL_ORIGIN}/#software`;

function organization() {
  return {
    '@type': 'Organization',
    '@id': ORG_ID,
    name: 'flowdo',
    url: CANONICAL_ORIGIN,
    logo: `${CANONICAL_ORIGIN}/logo192.png`,
    email: 'info@flowdo.biz',
  };
}

function website() {
  return {
    '@type': 'WebSite',
    '@id': WEBSITE_ID,
    name: 'flowdo',
    url: CANONICAL_ORIGIN,
    publisher: { '@id': ORG_ID },
  };
}

function softwareApplication(name, description, url) {
  return {
    '@type': 'SoftwareApplication',
    '@id': `${url}#app`,
    name,
    description,
    url,
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web',
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'USD',
      description: 'Every module starts free. Paid plans from $1 per month.',
    },
    publisher: { '@id': ORG_ID },
    image: ogImageUrl(),
  };
}

function breadcrumbs(pathname, page) {
  const items = [
    { name: 'Home', path: '/' },
  ];
  if (pathname === '/products' || pathname.startsWith('/products/')) {
    items.push({ name: 'Products', path: '/products' });
  }
  if (pathname !== '/' && pathname !== '/products') {
    const module = PRODUCT_MODULES.find((item) => item.to === pathname);
    items.push({ name: module?.title || page.pageTitle || page.heading || page.title, path: pathname });
  }

  if (items.length < 2) return null;

  return {
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: canonicalUrl(item.path),
    })),
  };
}

export function buildJsonLd(page) {
  if (!page?.index) return null;

  const url = canonicalUrl(page.path);
  const graph = [organization(), website()];

  if (page.path === '/') {
    graph.push(softwareApplication('flowdo', page.description, CANONICAL_ORIGIN));
  } else if (page.path.startsWith('/products')) {
    const module = PRODUCT_MODULES.find((item) => item.to === page.path);
    graph.push(softwareApplication(module?.title || 'flowdo', page.description, url));
  }

  const crumb = breadcrumbs(page.path, page);
  if (crumb) graph.push(crumb);

  return JSON.stringify({
    '@context': 'https://schema.org',
    '@graph': graph,
  });
}
